const Welcome = () => import('~/pages/welcome').then(m => m.default || m)
const NotFound = () => import('~/pages/errors/404').then(m => m.default || m)

const Login = () => import('~/pages/auth/login-v2').then(m => m.default || m)
const SoldOutProducts = () => import('~/pages/sold-out-products').then(m => m.default || m)
const BlackPiercers = () => import('~/pages/black-piercers').then(m => m.default || m)
const DigitalDownloads = () => import('~/pages/digital-downloads').then(m => m.default || m)
const EarCurations = () => import('~/pages/ear-curations').then(m => m.default || m)
const EarCuration = () => import('~/pages/ear-curation').then(m => m.default || m)
const Surveys = () => import('~/pages/surveys').then(m => m.default || m)
const Survey = () => import('~/pages/survey').then(m => m.default || m)

const Users = () => import('~/pages/users').then(m => m.default || m)
const User = () => import('~/pages/user').then(m => m.default || m)
const Profile = () => import('~/pages/settings/profile').then(m => m.default || m)

export default [
  { path: '/', name: 'home', component: SoldOutProducts },

  { path: '/login', name: 'login', component: Login },
  { path: '/sold-out-products', name: 'sold-out-products', component: SoldOutProducts },
  { path: '/black-piercers', name: 'black-piercers', component: BlackPiercers },
  { path: '/digital-downloads', name: 'digital-downloads', component: DigitalDownloads },
  { path: '/ear-curations', name: 'ear-curations', component: EarCurations },
  { path: '/ear-curation/:id', name: 'ear-curation', component: EarCuration },
  { path: '/surveys', name: 'surveys', component: Surveys },
  { path: '/survey/:id', name: 'survey', component: Survey },

  { path: '/users', name: 'users', component: Users },
  { path: '/user/:id', name: 'user', component: User },
  { path: '/profile', name: 'profile', component: Profile },
  { path: '*', component: NotFound },
]



// WEBPACK FOOTER //
// ./resources/js/router/routes.js